import React, { useState } from "react";

import { MyScheduleProductivity } from "../common/Helper";
import { DateRangeIcon } from "../common/Icon";

const MyShecdule = () => {
  // const currentDate = new Date();
  // // Get current year, month, and date
  // const year = currentDate.getFullYear();
  // const month = currentDate.getMonth() + 1;
  // const date = currentDate.getDate();
  // const fullDate =
  //   date.toString() + "-" + month.toString() + "-" + year.toString();

  const [checkBoxArray, setcheckBoxArray] = useState([]);

  const onClickHandler = (value) => {
    if (checkBoxArray.includes(value)) {
      const updateCheckBox = checkBoxArray.filter((obj) => obj !== value);
      setcheckBoxArray(updateCheckBox);
    } else {
      setcheckBoxArray([...checkBoxArray, value]);
    }
  };
  return (
    <>
      <div className="w-[500px] sm:w-auto overflow-x-auto overflow_x_scroll_style ">
        {MyScheduleProductivity.map((value, index) => {
          const inputCheckBox = checkBoxArray.includes(index);
          return (
            <div
              className=" p-[7px_10px] rounded-md  bg-white hover:shadow-workflow_item_card_shadow duration-300 cursor-pointer my-2 mx-[11px]"
              key={index}
              onClick={() => onClickHandler(index)}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <img src={value.myscheduleupsImg} alt="teams" />
                  <div>
                    <div className=" flex items-center gap-4">
                      <h5 className="text-sm  3xl:text-base font-normal text-black">
                        {value.myscheduleNameText}
                      </h5>
                      <div className="flex items-center gap-1">
                        <span>{value.myscheduleStatusIcon}</span>
                        <p
                          className={`${value.levelTextColor} text-xs 3xl:text-sm font-normal`}>
                          {value.myscheduleTeamLevelText}
                        </p>
                      </div>

                      <div className="gap-1 items-center hidden sm:flex ">
                        <span>
                          <DateRangeIcon />
                        </span>
                        <span className="text-[10px] 3xl:text-xs font-normal text-gray">
                          {value.fullDate}
                        </span>
                      </div>
                      <img
                        src={value.myschedulevideoicon}
                        alt="my-schedule-video-icon"
                      />
                    </div>
                  </div>
                </div>
                <div className=" flex items-center gap-[6px] plaining_input team_checkbox">
                  <input
                    aria-label="checkbox"
                    checked={inputCheckBox ? true : false}
                    type="checkbox"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default MyShecdule;
